import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {Flex} from "reflexbox";
import {Clear} from "@mui/icons-material";
import TextField from "@mui/material/TextField";

export const IncorrectGuesses = (userActions, pastAnswers) => {

  if(userActions && userActions.includes('incorrect')){
    return ('Incorrect guess'+ (pastAnswers.length > 1 ? 'es' : '') + ': ' + pastAnswers?.map((val, key )=>{
        //logic so that we don't include the correct answer in the incorrect list
        if(userActions[key] !== 'success'){
          return(` ${val}`)
        } else {
          return(null)
        }
        }
    ))
  }
};

const FreeText = (props) => {

  const {userAnswer, error, setError, userActions, pastAnswers, setUserAnswer, complete,  setDisableSubmit} = props;

  useEffect(()=>{
    //logic on whether to disable the submit button
    //check if the user has submitted something, also make sure its not an answer previously submitted
    if(userAnswer && !pastAnswers.includes(userAnswer) && !complete ) {
        setDisableSubmit(false);
    } else {
      setDisableSubmit(true)
    }
  },[userAnswer, userActions, complete]);

  return(<>
    <Flex style={{alignItems: 'center'}}>
      <TextField
        id="answer-input"
        label="Your answer"
        variant="filled"
        value={userAnswer || ""}
        disabled={complete}
        error={error}
        helperText={IncorrectGuesses(userActions, pastAnswers)}
        onChange={(e) => {
          setUserAnswer(e.target.value);
          error && setError(false);
        }}
        style={{marginTop: '8px', width: '100%'}}
      />
      <Flex id={'x button'} style={{position: 'relative', right: '30px', width: 0, visibility: !error && 'hidden'}}
            onClick={()=>{
              setUserAnswer('');
              setError(false)
            }}>
        <Clear/>
      </Flex>
    </Flex>
    </>)
};

FreeText.propTypes = {
  userAnswer: PropTypes.isRequired,
  error: PropTypes.isRequired,
  setError: PropTypes.func.isRequired,
  userActions: PropTypes.array.isRequired,
  pastAnswers: PropTypes.array.isRequired,
  setUserAnswer: PropTypes.func.isRequired,
  complete: PropTypes.isRequired,
  setDisableSubmit: PropTypes.func.isRequired,
};

export default FreeText;